import React from 'react';
import { Form } from 'antd';

const FormField = ({ label, name, rules, children }) => {
  return (
    <Form.Item label={label} name={name} rules={rules}>
      {children}
    </Form.Item>
  );
};

export default FormField;
